import { useState, useEffect, useRef } from "react";
import { UpdateMetaThemeColour } from "../Utils/UpdateMetaThemeColour";
import { returnBackgroundColour } from "../Utils/returnBackgroundColour";
import { getDayTypeUpdateFields } from "../Utils/dayTypeCalculator";
import Visibility from "visibilityjs";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import rrulePlugin from "@fullcalendar/rrule";
import listPlugin from "@fullcalendar/list";

import timeGridPlugin from "@fullcalendar/timegrid";
import enAu from "@fullcalendar/core/locales/en-au";

import { useHistory, useLocation } from "react-router-dom";
import queryString from "query-string";

import { use100vh } from "react-div-100vh";

import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme as useMUITheme } from "@mui/material/styles";
import Slide from "@mui/material/Slide";
import Modal from "@mui/material/Modal";

// import EventDataModal from "./EventDataModal";
import EventDataModalV2 from "./EventDataModalV2";
import { ConfirmedEmailV2, FirstConfirmationEmailV2 } from "../EmailModalV2";
import "./calendar.css";
import FiltersPopover from "./FiltersPopover";
import { eventContentWithListView } from "./eventContent";
import { useSwipeable } from "react-swipeable";

import ExportDatesModal from "./ExportDatesModal";

import { RRule } from "rrule";
import { v4 as uuidv4 } from "uuid";

import { createGlobalStyle } from "styled-components";

import { useAtom } from "jotai";
import {
  db,
  functions,
  onSnapshot,
  collection,
  doc,
  addDoc,
  updateDoc,
  increment,
  where,
  query,
  orderBy,
  httpsCallable,
  runTransaction,
} from "../firebaseConfig";
import {
  isIdleAtom,
  showEveryJobAtom,
  newJobObjectAtom,
  themeAtom,
  isElectronAtom,
  isMobileAtom,
  isMobileBrowserAtom,
  calendarColoursAtom,
  calendarEventsAtom,
  isDebouncingAtom,
  exportDatesModalOpenAtom,
  eventDataModalOpenAtom,
  showWeekendsAtom,
  queryFilterAtom,
  currentStaffDataAtom,
  showDoublesAtom,
  isDockHiddenAtom,
  modalAlignmentAtom,
  modalSubscriptionTimeoutAtom,
  visibilitySubscriptionTimeoutAtom,
  shouldPauseSubscriptionsAtom,
  isPageVisibleAtom,
} from "../-Atoms";

import { subscribe, unsubscribe } from "../GlobalFunctions/customEvent";

import DockFunctions from "../GlobalFunctions/DockFunctions";

// import * as confetti from 'canvas-confetti';
// https://join.slack.com/t/imagesthatsell/shared_invite/zt-2xph66cub-IQcSbFFM47AMhnxbh8bnBQ

// xoxb-8277165093222-8306644536672-PMI1nJWOmiULMlbXxchI2JyR

const confetti = require("canvas-confetti");
const { DateTime } = require("luxon");

const crypto = require("crypto");

const studios = [
  "Studio 1",
  "Studio 2A",
  "Studio 2B",
  "Studio 2C",
  "Studio 3",
  "Studio 4",
  "Staff",
  "N/A",
  "Critical Events",
  "Post Production",
  "Adam",
  "Location",
];

const jobTypes = [
  "Misc (-M)",
  "Creative Life (-LC)",
  "Creative Flatlay (-PC)",
  "Design (-D)",
  "Life (-L)",
  "Location Shoot (-L)",
  "Ghost (-P)",
  "Ghost/Flatlay (-P)",
  "Ghost/Product (-P)",
  "Ghost/Jewellery (-P)",
  "Flatlay (-P)",
  "Hanging Flatlay (-P)",
  "Jewellery (-P)",
  "Product (-P)",
  "Retouching (-R)",
  "Video (-V)",
  "Video Editing (-E)",
];

const CalendarGlobalStyles = createGlobalStyle`
  :root {
    --fc-button-text-color: #fff;
    --fc-button-bg-color: #${(props) =>
    props.theme === "dark" ? "202733" : "485773"};
    --fc-button-border-color: #${(props) =>
    props.theme === "dark" ? "202733" : "485773"};
    --fc-button-hover-bg-color: #${(props) =>
    props.theme === "dark" ? "283140" : "404d66"};
    --fc-button-hover-border-color: #${(props) =>
    props.theme === "dark" ? "283140" : "404d66"};
    --fc-button-active-bg-color: #${(props) =>
    props.theme === "dark" ? "2b3545" : "3d4a61"};
    --fc-button-active-border-color: #${(props) =>
    props.theme === "dark" ? "2b3545" : "3d4a61"};
  }
  ::-webkit-scrollbar {
    z-index:999999999999999;
    background-color: rgba(0, 0, 0, 0);
    width: ${(props) =>
    props.bgRand === props.adamFace || props.bgRand === props.soriahface
      ? "60px"
      : "8px"};
    height: ${(props) =>
    props.bgRand === props.adamFace || props.bgRand === props.soriahface
      ? "60px"
      : "8px"};
  }

  ::-webkit-scrollbar-thumb {
    z-index:999999999999999;
    ${(props) =>
    props.bgRand === props.adamFace || props.bgRand === props.soriahface
      ? `background-image: url("${props.bgRand === props.adamFace
        ? props.adamImage
        : props.bgRand === props.soriahface
          ? props.soriahImage
          : ""
      }");
    background-repeat: no-repeat;
    background-size: 220%;
    background-position: center;`
      : "background-color: rgba(80, 80, 80, 0.6);"}
    border-radius: 10px;
    cursor: pointer;
    border: 1px solid #0000004D
  }
  ::-webkit-scrollbar-thumb:hover {
    z-index:999999999999999;
    background-color: rgba(120, 120, 120, 0.6);
  }
  .darkModeBorder td,
  .darkModeBorder th {
    border: 1px solid ${(props) =>
    props.theme === "dark"
      ? "rgba(255, 255, 255, 0.05)"
      : "#dddddd"} !important;
  }

  .fc-listWeek-view, .fc-listDay-view, .fc-listMonth-view {
    border:none !important;
  }

  .fc-list-day, .fc .fc-list-event:hover td {
    background: #${(props) =>
    props.theme === "dark"
      ? returnBackgroundColour("dark")
      : returnBackgroundColour("light")} !important;
    background-color: #${(props) =>
    props.theme === "dark"
      ? returnBackgroundColour("dark")
      : returnBackgroundColour("light")} !important;
  }

   .fc {
    background: #${(props) =>
    props.theme === "dark"
      ? returnBackgroundColour("dark")
      : returnBackgroundColour("light")} !important;
    background-color: #${(props) =>
    props.theme === "dark"
      ? returnBackgroundColour("dark")
      : returnBackgroundColour("light")} !important;

  }

  .fc .fc-cell-shaded, .fc .fc-day-disabled {
    background: #${(props) =>
    props.theme === "dark"
      ? returnBackgroundColour("dark")
      : returnBackgroundColour("light")} !important;
    background-color: #${(props) =>
    props.theme === "dark"
      ? returnBackgroundColour("dark")
      : returnBackgroundColour("light")} !important;
  } 

  .fc-footer-toolbar{
    margin-top: 15px !important;
  }
  
  .list-event-item:hover{
    opacity: 0.95 !important;
    transform: translateX(3px) !important;
    box-shadow: 0 4px 12px rgba(${(props) =>
    props.theme === "dark"
      ? "150, 150, 150, 0.1"
      : "0, 0, 0, 0.15"}) !important;
  }
    .fc-timegrid-event:hover{
    opacity: 0.95 !important;
    transform: translateX(1px) !important;
    box-shadow: 0 4px 12px rgba(${(props) =>
    props.theme === "dark"
      ? "150, 150, 150, 0.1"
      : "0, 0, 0, 0.15"}) !important;
  }
`;

// Constants for GlobalStyles
const adamFace = 42;
const soriahface = 3333;
const adamImage =
  "https://firebasestorage.googleapis.com/v0/b/its-connect-main.appspot.com/o/Staff%20Profile%20Pictures%2FCLJqPv7r8yHYwUv87TpH.jpeg?alt=media&token=e2e23596-5745-4a8d-b67b-820dc81086dc";
const soriahImage =
  "https://firebasestorage.googleapis.com/v0/b/its-connect-main.appspot.com/o/Random%20Images%2FIMG_2040.jpg?alt=media&token=29d981c9-b621-4f43-b7d3-2427a9d0b6b1";

const Calendar = ({ user, anon, newCardID }) => {
  const [theme] = useAtom(themeAtom);
  const [newJobObject] = useAtom(newJobObjectAtom);
  const [isElectron] = useAtom(isElectronAtom);
  const [isMobileBrowser] = useAtom(isMobileBrowserAtom);
  const [isMobile] = useAtom(isMobileAtom);
  const [calendarColours] = useAtom(calendarColoursAtom);
  const [, setCalendarEvents] = useAtom(calendarEventsAtom);
  const [exportDatesModalOpen, setExportDatesModalOpen] = useAtom(
    exportDatesModalOpenAtom
  );
  const [eventDataModalOpen, setEventDataModalOpen] = useAtom(
    eventDataModalOpenAtom
  );
  const [eventDataModal, setEventDataModal] = useState({});
  const [eventDataModalV2Open, setEventDataModalV2Open] = useState(false);

  const [showDoubles] = useAtom(showDoublesAtom);
  const [isDockHidden] = useAtom(isDockHiddenAtom);
  const [modalAlignment] = useAtom(modalAlignmentAtom);

  const { showDock, hideDock } = DockFunctions();

  const [startEndDate, setStartEndDate] = useState({
    startDate: null,
    endDate: null,
  });

  const [currentStaffData] = useAtom(currentStaffDataAtom);

  const history = useHistory();
  const location = useLocation();

  // View mapping logic for list/grid toggle
  const getCorrespondingView = (view, toListView) => {
    const viewMap = {
      dayGridMonth: "listMonth",
      timeGridWeek: "listWeek",
      timeGridDay: "listDay",
      listMonth: "dayGridMonth",
      listWeek: "timeGridWeek",
      listDay: "timeGridDay",
    };

    if (toListView) {
      return viewMap[view] || "listWeek";
    } else {
      return viewMap[view] || "timeGridWeek";
    }
  };

  // Toggle between list and grid views
  const toggleListView = () => {
    if (!calendarRef.current) return;

    const newIsListView = !isListView;
    const newView = getCorrespondingView(currentView, newIsListView);

    setIsListView(newIsListView);
    calendarRef.current.getApi().changeView(newView);
  };

  const [showEveryJob] = useAtom(showEveryJobAtom);

  const [currentView, setCurrentView] = useState("timeGridWeek");
  const [isListView, setIsListView] = useState(false);
  const [events, setEvents] = useState([]);
  const [birthdays, setBirthdays] = useState([]);
  const [publicHolidays, setPublicHolidays] = useState([]);

  const [isIdle] = useAtom(isIdleAtom);

  // Use global atoms for subscription management
  const [MODAL_SUBSCRIPTION_TIMEOUT] = useAtom(modalSubscriptionTimeoutAtom);
  const [VISIBILITY_SUBSCRIPTION_TIMEOUT] = useAtom(
    visibilitySubscriptionTimeoutAtom
  );
  const [shouldPauseSubscriptions, setShouldPauseSubscriptions] = useAtom(
    shouldPauseSubscriptionsAtom
  );
  const [isPageVisible, setIsPageVisible] = useAtom(isPageVisibleAtom);

  useEffect(() => {
    // Don't subscribe when subscriptions should be paused
    if (shouldPauseSubscriptions) {
      return;
    }

    const unsubPublicHolidays = onSnapshot(
      collection(db, "PublicHolidays"),
      (collection) => {
        const holidays = [];

        collection.docs.forEach((doc) => {
          const holidayData = doc.data();

          // Create all-day event
          holidays.push({
            id: `holiday-${doc.id}-allDay`,
            title: `${holidayData.title}`,
            start: holidayData.start,
            end: holidayData.end,
            allDay: true,
            isPublicHoliday: true,
            borderColor: "rgba(0, 0, 0, 0)",
            textColor: theme === "dark" ? "rgb(240,240,240)" : "rgb(30,30,30)",
            studio: "----",
          });

          // Create non-all-day event
          holidays.push({
            id: `holiday-${doc.id}`,
            title: `${holidayData.title}`,
            start: holidayData.start,
            end: holidayData.end,
            allDay: false,
            isPublicHoliday: true,
            borderColor: "rgba(0, 0, 0, 0)",
            textColor: theme === "dark" ? "rgb(240,240,240)" : "rgb(30,30,30)",
            studio: "----",
          });
        });

        setPublicHolidays(holidays);
      },
      (error) => {
        // alert("Error - Public Holidays", error);
      }
    );

    return () => {
      unsubPublicHolidays();
    };
  }, [theme, shouldPauseSubscriptions]);

  const [filteredEvents, setFilteredEvents] = useState([]);
  const [recurringEvents, setRecurringEvents] = useState([]);
  const [clientData, setClientData] = useState([]);
  const [staffData, setStaffData] = useState([]);
  const [showWeekends, setShowWeekends] = useAtom(showWeekendsAtom);

  const [queryFilter, setQueryFilter] = useAtom(queryFilterAtom);

  const [showStaff, setShowStaff] = useState(true);
  const [broadClientFilter, setBroadClientFilter] = useState(false);

  function isPushNotificationSupported() {
    return "serviceWorker" in navigator && "PushManager" in window;
  }

  function getUserSubscription() {
    return navigator.serviceWorker.ready
      .then(function (serviceWorker) {
        return serviceWorker.pushManager.getSubscription();
      })
      .then(function (pushSubscription) {
        return pushSubscription;
      });
  }

  function registerServiceWorker() {
    return navigator.serviceWorker.register("/sw.js");
  }
  const savePushNotificationSubscriptionToUserData = httpsCallable(
    functions,
    "savePushNotificationSubscriptionToUserData"
  );
  function createHash(input) {
    const md5sum = crypto.createHash("md5");
    md5sum.update(Buffer.from(input));
    return md5sum.digest("hex");
  }
  const checkRegistered = async () => {
    try {
      let res = false;

      if (!isPushNotificationSupported()) {
        return false;
      }
      if (!("serviceWorker" in navigator)) {
        return false;
      }

      const serviceWorkers = await navigator.serviceWorker.getRegistrations();

      if (serviceWorkers.length === 0) {
        return false;
      }

      const subscription = await getUserSubscription();

      const subscriptionId = createHash(JSON.stringify(subscription));
      currentStaffData.notificationSubscriptions.forEach((sub) => {
        if (sub.id === subscriptionId) {
          res = true;
        }
      });
      return res;
    } catch (e) {
      console.log(e);
      return false;
    }
  };

  const setupNotifications = async () => {
    const registered = await checkRegistered();
    if (registered) {
      return;
    }
    if (!isPushNotificationSupported()) {
      return;
    }
    if (Notification.permission !== "granted") {
      return;
    }
    registerServiceWorker();
    const serviceWorker = await navigator.serviceWorker.ready;
    const subscriptionRaw = await serviceWorker.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey:
        "BKluKzkYf9wTIVmdWJMy9szdvr-utCUC5XqlAZgLvcTrqDAuGYynQMFZaHYFLozzyxukkGZ6-FxjGYvUxPv2x7w",
    });
    const subscription = JSON.parse(JSON.stringify(subscriptionRaw));
    await savePushNotificationSubscriptionToUserData({
      subscription: subscription,
    });
  };

  const swipeHandlers = useSwipeable({
    onSwipedRight: (eventData) => {
      calendarRef.current.getApi().prev();
      if (isMobileBrowser) {
        setupNotifications();
      }
    },
    onSwipedLeft: (eventData) => {
      calendarRef.current.getApi().next();
      if (isMobileBrowser) {
        setupNotifications();
      }
    },
    preventScrollOnSwipe: true,
  });

  useEffect(() => {
    if (anon) {
      document.title = "ITS Calendar";
    }
  }, [anon]);

  useEffect(() => {
    const main = () => {
      if (!currentStaffData?.id) return;
      if (showEveryJob) {
      } else {
        if (currentStaffData.isUtility) return;
        if (currentStaffData.isAdmin) return;
        if (currentStaffData.isSuperAdmin) return;
        setQueryFilter({ ...queryFilter, staff: [currentStaffData] });
        return;
      }
    };
    main();
    // eslint-disable-next-line
  }, [user, currentStaffData, setQueryFilter]);

  useEffect(() => {
    const ele = document.getElementById("calendarRoot");
    if (!ele) return;
    if (eventDataModalOpen) {
      ele.style.filter = "blur(1px)";
    } else {
      ele.style.filter = "";
    }
  }, [eventDataModalOpen]);

  // Manage page visibility
  useEffect(() => {
    const handleVisibilityChange = () => {
      setIsPageVisible(!Visibility.hidden());
    };

    // Set initial visibility state
    setIsPageVisible(!Visibility.hidden());

    // Listen for visibility changes
    Visibility.change(handleVisibilityChange);

    return () => {
      // Use try-catch to handle any unbind issues safely
      try {
        Visibility.unbind(handleVisibilityChange);
      } catch (e) {
        console.log("Visibility unbind error:", e);
      }
    };
  }, [setIsPageVisible]);

  // Manage subscription timeout when modals are open or page is hidden
  useEffect(() => {
    const isAnyModalOpen = eventDataModalOpen || eventDataModalV2Open;
    let modalTimeoutId;
    let visibilityTimeoutId;

    if (isAnyModalOpen) {
      // Set timeout to pause subscriptions after modal timeout
      modalTimeoutId = setTimeout(() => {
        setShouldPauseSubscriptions(true);
      }, MODAL_SUBSCRIPTION_TIMEOUT);
    } else if (!isPageVisible) {
      // Set timeout to pause subscriptions after visibility timeout (longer)
      visibilityTimeoutId = setTimeout(() => {
        setShouldPauseSubscriptions(true);
      }, VISIBILITY_SUBSCRIPTION_TIMEOUT);
    } else {
      // Page is visible and no modals open - resume subscriptions
      setShouldPauseSubscriptions(false);
    }

    return () => {
      if (modalTimeoutId) {
        clearTimeout(modalTimeoutId);
      }
      if (visibilityTimeoutId) {
        clearTimeout(visibilityTimeoutId);
      }
    };
  }, [
    eventDataModalOpen,
    eventDataModalV2Open,
    isPageVisible,
    MODAL_SUBSCRIPTION_TIMEOUT,
    VISIBILITY_SUBSCRIPTION_TIMEOUT,
    setShouldPauseSubscriptions,
  ]);

  const calendarRef = useRef(null);

  const { search } = useLocation();

  useEffect(() => {
    if (calendarRef) {
      const qs = queryString.parse(search);
      if (qs.jumpto) {
        const api = calendarRef?.current?.getApi();
        try {
          const d = new Date(parseInt(qs.jumpto));
          api.gotoDate(d);
        } catch (e) { }
      }
    }
  }, [search, calendarRef]);

  const height = use100vh();

  const MUITheme = useMUITheme();
  const isMidSize = useMediaQuery(MUITheme.breakpoints.down("lg"));

  useEffect(() => {
    if (calendarRef) {
      if (!isMobile) {
        calendarRef.current.getApi().changeView("timeGridWeek");
      } else {
        calendarRef.current.getApi().changeView("timeGridDay");
      }
    }
  }, [isMobile, calendarRef]);

  useEffect(() => {
    const handleCalendarPrevious = () => {
      calendarRef.current.getApi().prev();
    };
    const handleCalendarNext = () => {
      calendarRef.current.getApi().next();
    };
    subscribe("calendarPrevious", handleCalendarPrevious);
    subscribe("calendarNext", handleCalendarNext);

    return () => {
      unsubscribe("calendarPrevious", handleCalendarPrevious);
      unsubscribe("calendarNext", handleCalendarNext);
    };
  }, [calendarRef]);

  const [staffDataInitialLoad, setStaffDataInitialLoad] = useState(true);

  useEffect(() => {
    // Don't subscribe when subscriptions should be paused
    if (shouldPauseSubscriptions) {
      return;
    }

    // Add 5 second delay only on first load
    const delay = staffDataInitialLoad ? 1000 : 0;

    const timeoutId = setTimeout(() => {
      let unsub = onSnapshot(
        query(collection(db, "StaffData"), orderBy("firstName", "asc")),
        (collection) => {
          const sd = collection.docs.map((staff) => {
            const staffDataRaw = staff.data();
            const data = {};
            data.id = staff.id;
            data.email = staffDataRaw.email;
            data.firstName = staffDataRaw.firstName;
            data.lastName = staffDataRaw.lastName;
            data.isUtility = staffDataRaw.isUtility;
            data.isAdmin = staffDataRaw.isAdmin;
            data.isSuperAdmin = staffDataRaw.isSuperAdmin;
            data.preferredName = staffDataRaw.preferredName;
            data.avatar = staffDataRaw.avatar;
            data.dateOfBirth = staffDataRaw.dateOfBirth;
            data.currentlyEmployed = staffDataRaw.currentlyEmployed;
            data.wwccCheckNumber = staffDataRaw.wwccCheckNumber;
            data.wwccExpiry = staffDataRaw.wwccExpiry;
            return data;
          });
          let newSd = [];
          let bdays = [];
          sd.forEach((s) => {
            const bDayObject = {
              id: `${s.id}-Birthday`,
              studio: "----",
              isBirthday: true,
              photographer: s.id,

              borderColor: "#900f70",
              textColor: "#900f70",
              allDay: true,
              title: `🎂 ${s.preferredName ? s.preferredName : s.firstName
                }'s Birthday 🎂`,
              startOrig: s.dateOfBirth,
            };
            if (s) newSd.push(s);
            if (
              s.dateOfBirth &&
              s.currentlyEmployed &&
              typeof s.dateOfBirth === "string"
            ) {
              bdays.push({
                ...bDayObject,
                rrule: {
                  freq: RRule.YEARLY,
                  interval: 1,
                  dtstart: s.dateOfBirth,
                },
              });
              const thisYear = DateTime.now().setZone("Australia/Sydney").year;
              const theBirthday = DateTime.fromISO(s.dateOfBirth);
              const newBirthday = theBirthday.set({ year: thisYear });
              const newBirthdayDayOfWeek = newBirthday.toLocaleString({
                weekday: "short",
              });
              if (newBirthdayDayOfWeek === "Sat") {
                const tmp = newBirthday
                  .minus({ days: 1 })
                  .setZone("Australia/Sydney")
                  .toUTC()
                  .toISO();
                bdays.push({
                  ...bDayObject,
                  startOrig: tmp,
                  start: tmp,
                  title: `🎂 ${s.preferredName ? s.preferredName : s.firstName
                    }'s Birthday (Sat) 🎂`,
                });
              } else if (newBirthdayDayOfWeek === "Sun") {
                const tmp = newBirthday
                  .minus({ days: 2 })
                  .setZone("Australia/Sydney")
                  .toUTC()
                  .toISO();
                bdays.push({
                  ...bDayObject,
                  startOrig: tmp,
                  start: tmp,
                  title: `🎂 ${s.preferredName ? s.preferredName : s.firstName
                    }'s Birthday (Sun) 🎂`,
                });
              }
            }
          });
          setStaffData([...newSd]);

          setBirthdays(bdays);
        },
        (error) => {
          // alert("Error - StaffData Birthdays", error);
        }
      );

      setStaffDataInitialLoad(false); // Mark as no longer initial load

      return () => {
        unsub();
      };
    }, delay);

    return () => {
      clearTimeout(timeoutId);
    };
    // eslint-disable-next-line
  }, [user, isIdle, startEndDate, shouldPauseSubscriptions]);

  const [clientDataInitialLoad, setClientDataInitialLoad] = useState(true);

  useEffect(() => {
    // Don't subscribe when subscriptions should be paused
    if (shouldPauseSubscriptions) {
      return;
    }

    // Add 5 second delay only on first load
    const delay = clientDataInitialLoad ? 5000 : 0;

    const timeoutId = setTimeout(() => {
      let unsub = onSnapshot(
        query(collection(db, "ClientDatabase"), orderBy("brand", "asc")),
        (collection) => {
          const cd = collection.docs.map((client) => {
            const data = client.data();
            data.id = client.id;
            return data;
          });
          setClientData([
            { id: "addNewClient", brand: "Add New Client..." },

            ...cd,
          ]);
        },
        (error) => {
          // alert("Error - ClientDatabase", error);
        }
      );

      setClientDataInitialLoad(false); // Mark as no longer initial load

      return () => {
        unsub();
      };
    }, delay);

    return () => {
      clearTimeout(timeoutId);
    };
    // eslint-disable-next-line
  }, [isIdle, shouldPauseSubscriptions]);

  useEffect(() => {
    // Don't subscribe when subscriptions should be paused
    if (shouldPauseSubscriptions) {
      return;
    }

    let unsub;
    const main = () => {
      if (startEndDate === null) return;
      unsub = onSnapshot(
        query(
          collection(db, "JobData"),
          where("bookedStart", ">=", startEndDate.startDate),
          where("bookedStart", "<=", startEndDate.endDate),
          orderBy("bookedStart", "desc")
        ),
        async (collection) => {
          const jd = collection.docs.map((job) => {
            const data = job.data();

            const event = { extendedProps: { ...data } };
            if (!data.shootDate) {
              return false;
            }
            if (data.recurringEvent) return false;

            if (!data.bookedStart || !data.bookedFinish) return false;
            if (data.allDay) {
              event.title = data.title;

              try {
                event.start = parseStartEndTime(
                  data.bookedStart,
                  data.bookedFinish,
                  data.shootDate,
                  "startDate",
                  data
                );
                event.end = parseStartEndTime(
                  data.bookedStart,
                  data.bookedFinish,
                  data.shootDate,
                  "endDate",
                  data
                );
              } catch (e) {
                if (currentStaffData?.id === "8jXVYoCymxHLQngklbWE") {
                  console.error(`Invalid Date - Offending Document: https://console.firebase.google.com/u/0/project/its-connect-main/firestore/databases/-default-/data/~2FJobData~2F${job.id}`);
                }
                throw e;
              }
              if (calendarColours[data.studio]) {
                event.backgroundColor = data.studio
                  ? theme === "dark"
                    ? calendarColours[data.studio].darkBackground || "#000000"
                    : calendarColours[data.studio].background || "#000000"
                  : theme === "dark"
                    ? calendarColours["Studio 1"].darkBackground || "#000000"
                    : calendarColours["Studio 1"].background || "#000000";

                event.borderColor = data.studio
                  ? theme === "dark"
                    ? calendarColours[data.studio].darkBackground || "#000000"
                    : calendarColours[data.studio].background || "#000000"
                  : theme === "dark"
                    ? calendarColours["Studio 1"].darkBackground || "#000000"
                    : calendarColours["Studio 1"].background || "#000000";

                event.boxShadow = "0px 0px 0px 0px #fff !important";
                event.textColor = data.studio
                  ? theme === "dark"
                    ? calendarColours[data.studio].darkText || "#000000"
                    : calendarColours[data.studio].text || "#000000"
                  : theme === "dark"
                    ? calendarColours["Studio 1"].darkBackground || "#000000"
                    : calendarColours["Studio 1"].background || "#000000";
              } else {
                event.backgroundColor = "#000000";
                event.borderColor = "#000000";
                event.boxShadow = "0px 0px 0px 0px #fff !important";
                event.textColor = "#000000";
              }
              event.id = job.id;
              event.allDay = true;
              if (data.recurringEvent) {
                event.rrule = data.rrule;
              }
            } else {
              if (data.recurringEvent) {
                event.rrule = data.rrule;
              }
              event.title = `${data.client} ${data.jobTypeFull ? "-" : ""} ${data.jobTypeFull || data.title || ""
                } `;
              try {
                event.start = parseStartEndTime(
                  data.bookedStart,
                  data.bookedFinish,
                  data.shootDate,
                  "startDate",
                  data
                );
                event.end = parseStartEndTime(
                  data.bookedStart,
                  data.bookedFinish,
                  data.shootDate,
                  "endDate",
                  data
                );
              } catch (e) {
                if (currentStaffData?.id === "8jXVYoCymxHLQngklbWE") {
                  console.error(`Invalid Date - Offending Document: https://console.firebase.google.com/u/0/project/its-connect-main/firestore/databases/-default-/data/~2FJobData~2F${job.id}`);
                }
                throw e;
              }

              event.backgroundColor = data.studio
                ? theme === "dark"
                  ? calendarColours[data.studio].darkBackground || "#000000"
                  : calendarColours[data.studio].background || "#000000"
                : theme === "dark"
                  ? calendarColours["Studio 1"].darkBackground || "#000000"
                  : calendarColours["Studio 1"].background || "#000000";
              event.borderColor = data.studio
                ? theme === "dark"
                  ? calendarColours[data.studio].darkBackground || "#000000"
                  : calendarColours[data.studio].background || "#000000"
                : theme === "dark"
                  ? calendarColours["Studio 1"].darkBackground || "#000000"
                  : calendarColours["Studio 1"].background || "#000000";
              event.boxShadow = "0px 0px 0px 0px #fff !important";
              event.textColor = data.studio
                ? theme === "dark"
                  ? calendarColours[data.studio].darkText || "#000000"
                  : calendarColours[data.studio].text || "#000000"
                : theme === "dark"
                  ? calendarColours["Studio 1"].darkBackground || "#000000"
                  : calendarColours["Studio 1"].background || "#000000";
              event.id = job.id;
              event.allDay = false;
            }

            return event;
          });

          const jdUpdated = [];
          jd.forEach((j) => {
            if (j) jdUpdated.push(j);
            if (j?.extendedProps?.additionalDates) {
              j.extendedProps.additionalDates.forEach((ad, index) => {
                if (ad.start && ad.end) {
                  const newJ = {};
                  const keys = Object.keys(j);
                  keys.forEach((key) => {
                    newJ[key] = j[key];
                  });
                  newJ.start = ad.start;
                  newJ.end = ad.end;
                  newJ.isAdditionalDate = true;
                  newJ.additionalDateIndex = index;
                  newJ.title = `🔗 ${newJ.title}`;
                  newJ.editable = false;
                  newJ.extendedProps = { ...j.extendedProps };
                  newJ.extendedProps.photographer = ad.photographer;
                  newJ.extendedProps.additionalPhotographers =
                    ad.additionalPhotographers;
                  newJ.extendedProps.operator = ad.operator;
                  newJ.extendedProps.additionalOperators =
                    ad.additionalOperators;
                  newJ.extendedProps.stylist = ad.stylist;
                  newJ.extendedProps.additionalStylists = ad.additionalStylists;

                  jdUpdated.push(newJ);
                }
              });
            }
          });

          setEvents([...jdUpdated]);
          setCalendarEvents([...jdUpdated]);

          setTimeout(() => {
            setLoadingVisible(false);
          }, 500);
        },
        (error) => {
          // alert("Error - JobData", error);
        }
      );
    };
    main();

    return () => {
      try {
        unsub();
      } catch (e) {
        console.log("no unsub");
      }
    };
  }, [
    startEndDate,
    isIdle,
    theme,
    setCalendarEvents,
    calendarColours,
    shouldPauseSubscriptions,
  ]);

  useEffect(() => {
    // Don't subscribe when subscriptions should be paused
    if (shouldPauseSubscriptions) {
      return;
    }

    let unsub;
    const main = async () => {
      // const recurringTmp = [];
      unsub = onSnapshot(
        query(collection(db, "JobData"), where("recurringEvent", "==", true)),
        async (collection) => {
          const jd = collection.docs.map((re) => {
            const data = re.data();
            data.id = re.id;
            const event = { extendedProps: { ...data } };
            event.title = data.title;
            event.allDay = true;
            event.backgroundColor =
              theme === "dark"
                ? calendarColours[data.studio].darkBackground || "#000000"
                : calendarColours[data.studio].background || "#000000";
            event.borderColor =
              theme === "dark"
                ? calendarColours[data.studio].darkBackground || "#000000"
                : calendarColours[data.studio].background || "#000000";
            event.boxShadow = "0px 0px 0px 0px #fff !important";
            event.textColor = data.studio
              ? theme === "dark"
                ? calendarColours[data.studio].darkText || "#000000"
                : calendarColours[data.studio].text || "#000000"
              : null;
            try {
              event.start = parseStartEndTime(
                data.bookedStart,
                data.bookedFinish,
                data.shootDate,
                "startDate",
                data
              );
              event.end = parseStartEndTime(
                data.bookedStart,
                data.bookedFinish,
                data.shootDate,
                "endDate",
                data
              );
            } catch (e) {
              if (currentStaffData?.id === "8jXVYoCymxHLQngklbWE") {
                console.error(`Invalid Date in recurring event - Offending Document: https://console.firebase.google.com/u/0/project/its-connect-main/firestore/databases/-default-/data/~2FJobData~2F${re.id}`);
              }
              throw e;
            }
            if (data.recurringEvent) {
              event.rrule = data.rrule;
              if (data.exdate) {
                event.exdate = data.exdate;
              }
            }
            return event;
          });
          setRecurringEvents([...jd]);
        },
        (error) => {
          // alert("Error - RecurringEvents", error);
        }
      );
    };
    main();

    return () => {
      try {
        unsub();
      } catch (e) {
        console.log("no unsub");
      }
    };
  }, [isIdle, calendarColours, theme, shouldPauseSubscriptions]);

  const addAllDayEvents = (array, arrayToUpdate) => {
    const staffAllDay = [];
    array.forEach((j) => {
      if (j) {
        if (!j.allDay) {
          const date = new Date(j.start);
          date.setHours(0);
          date.setMinutes(0);
          const obj = {
            shootDate: date,
            start: j.start,
            end: j.end,
            studio: j.extendedProps.studio,
            photographer: j.extendedProps.photographer,
            additionalPhotographers: j.extendedProps.additionalPhotographers,
            operator: j.extendedProps.operator,
            additionalOperators: j.extendedProps.additionalOperators,
            stylist: j.extendedProps.stylist,
            additionalStylists: j.extendedProps.additionalStylists,
            allDay: true,
            id: j.extendedProps.id || j.id,
            backgroundColor: j.extendedProps.studio
              ? theme === "dark"
                ? calendarColours[j.extendedProps.studio].darkBackground ||
                "#000000"
                : calendarColours[j.extendedProps.studio].background ||
                "#000000"
              : null,
            textColor: j.extendedProps.studio
              ? theme === "dark"
                ? calendarColours[j.extendedProps.studio].darkText || "#000000"
                : calendarColours[j.extendedProps.studio].text || "#000000"
              : null,
            borderColor: j.extendedProps.studio
              ? theme === "dark"
                ? calendarColours[j.extendedProps.studio].darkBackground ||
                "#000000"
                : calendarColours[j.extendedProps.studio].background ||
                "#000000"
              : null,
            confirmationStatus: j.extendedProps.confirmationStatus,
            staffAllDay: true,
            editable: false,
            jobTypeFull: j.extendedProps.jobTypeFull,
            eventPrefix: j.extendedProps.eventPrefix,
            eventPrefixCustom: j.extendedProps.eventPrefixCustom,
            display: currentView === "dayGridMonth" ? "none" : "auto",
          };

          const arrayContains = staffAllDay.some((s) => {
            let shootDate = false;
            let photographer = false;
            let operator = false;
            let stylist = false;
            let studio = false;
            if (s.shootDate.toString() === obj.shootDate.toString()) {
              shootDate = true;
            }
            if (s.photographer === obj.photographer) {
              photographer = true;
            }
            if (s.operator === obj.operator) {
              operator = true;
            }
            if (s.stylist === obj.stylist) {
              stylist = true;
            }
            if (s.studio === obj.studio) {
              studio = true;
            }
            if (shootDate && photographer && operator && stylist && studio) {
              return true;
            }
            return false;
          });
          if (!arrayContains) {
            staffAllDay.push(obj);
          }
        }
      }
    });
    staffAllDay.forEach((s) => {
      if (s) {
        if (s.studio !== "Critical Events") {
          if (s.studio !== "Post Production") {
            if (s.studio !== "Staff") {
              if (s.studio !== "Adam") {
                arrayToUpdate.push(s);
              }
            }
          }
        }
      }
    });
  };

  useEffect(() => {
    if (!queryFilter) {
      let tmpArr = [];
      addAllDayEvents(events, tmpArr);

      // In list view, only show original events (no duplicate staff events)
      if (isListView) {
        // Sort events to group all-day items together at the top
        const sortedEvents = [...events].sort((a, b) => {
          // First sort by date, then by all-day status (all-day first), then by time
          const dateA = new Date(a.start || a.shootDate);
          const dateB = new Date(b.start || b.shootDate);

          if (dateA.toDateString() !== dateB.toDateString()) {
            return dateA - dateB; // Sort by date first
          }

          // Same date - put all-day events first
          if (a.allDay !== b.allDay) {
            return b.allDay - a.allDay; // all-day events (true) come first
          }

          // Same all-day status - sort by time for non-all-day events
          if (!a.allDay && !b.allDay) {
            return dateA - dateB;
          }

          return 0; // Keep original order for all-day events
        });
        setFilteredEvents(sortedEvents);
      } else {
        setFilteredEvents([...events, ...tmpArr]);
      }
      return;
    }
    let tmpArrUpdated = [];

    const filterStaff = (event, queryFilter) => {
      if (!queryFilter?.staff) return true;
      if (queryFilter?.staff?.length === 0) return true;
      let returnValue = false;
      queryFilter.staff.forEach((filter) => {
        if (event.extendedProps.studio === "N/A") returnValue = true;
        if (event.extendedProps.studio === "Staff") returnValue = true;
        if (
          event.extendedProps.studio === "Critical Events" ||
          event.extendedProps.studio === "Post Production"
        ) {
          if (!event.extendedProps.photographer) returnValue = true;
          if (event.extendedProps.photographer === queryFilter.staff) {
            returnValue = true;
          }
          returnValue = false;
        }

        if (event.extendedProps.photographer === filter.id) {
          returnValue = true;
        }
        if (event.extendedProps.stylist === filter.id) {
          returnValue = true;
        }
        if (event.extendedProps.operator === filter.id) {
          returnValue = true;
        }
        if (event.extendedProps.additionalPhotographers?.includes(filter.id)) {
          returnValue = true;
        }
        if (event.extendedProps.additionalOperators?.includes(filter.id)) {
          returnValue = true;
        }
        if (event.extendedProps.additionalStylists?.includes(filter.id)) {
          returnValue = true;
        }
      });
      return returnValue;
    };

    const filterStudio = (event, queryFilter) => {
      if (!queryFilter.studio) return true;
      if (queryFilter.studio.includes("All Studios")) return true;
      if (queryFilter.studio.includes(event.extendedProps.studio)) return true;
      return false;
    };

    const filterClient = (event, queryFilter) => {
      if (!queryFilter.client) return true;

      if (broadClientFilter) {
        queryFilter.client.forEach((cl) => {
          if (event.extendedProps.client.includes(cl)) {
            return true;
          }
        });
      } else {
        if (queryFilter.client.includes(event.extendedProps.client)) {
          return true;
        }
      }
    };
    const tmpArr = events.filter((event) => {
      return (
        filterStaff(event, queryFilter) &&
        filterStudio(event, queryFilter) &&
        filterClient(event, queryFilter)
      );
    });
    addAllDayEvents(tmpArr, tmpArrUpdated);

    // In list view, only show original events (no duplicate staff events)
    if (isListView) {
      // Sort filtered events to group all-day items together at the top
      const sortedFilteredEvents = [...tmpArr].sort((a, b) => {
        // First sort by date, then by all-day status (all-day first), then by time
        const dateA = new Date(a.start || a.shootDate);
        const dateB = new Date(b.start || b.shootDate);

        if (dateA.toDateString() !== dateB.toDateString()) {
          return dateA - dateB; // Sort by date first
        }

        // Same date - put all-day events first
        if (a.allDay !== b.allDay) {
          return b.allDay - a.allDay; // all-day events (true) come first
        }

        // Same all-day status - sort by time for non-all-day events
        if (!a.allDay && !b.allDay) {
          return dateA - dateB;
        }

        return 0; // Keep original order for all-day events
      });
      setFilteredEvents(sortedFilteredEvents);
    } else {
      setFilteredEvents([...tmpArr, ...tmpArrUpdated]);
    }
    // eslint-disable-next-line
  }, [queryFilter, events, broadClientFilter, isListView]);

  const desktopGridToolbar = {
    left: "title",
    center: "dayGridMonth,timeGridWeek,timeGridDay,toggleListView",
    right: `filters toggleWeekends prev,today,next`,
  };

  const desktopListToolbar = {
    left: "title",
    center: "customListMonth,customListWeek,customListDay,toggleListView",
    right: `filters toggleWeekends prev,today,next`,
  };

  const desktopToolbar = isListView ? desktopListToolbar : desktopGridToolbar;

  const mobileToolbar = {
    left: "title",
    center: "",
    right: "toggleListView mobileMenuButton",
  };
  const resetEvent = (event) => {
    if (event && event.revert) {
      event.revert(); // Use FullCalendar's built-in revert method to properly clean up the UI
    } else if (event && event.event && event.oldEvent) {
      calendarRef.current.getApi().unselect();
      event.event.setStart(event.oldEvent.start);
      event.event.setEnd(event.oldEvent.end);
    }
    // Force a refresh to ensure UI is clean
    calendarRef.current.getApi().refetchEvents();
  };
  const createNewEvent = async (event) => {
    if (!currentStaffData) {
      calendarRef.current.getApi().unselect();
      return;
    }
    if (currentStaffData.isUtility) {
      calendarRef.current.getApi().unselect();
      return;
    }
    calendarRef.current.getApi().unselect();
    let persistedDateFields;
    try {
      persistedDateFields = buildPersistedDateFields({
        start: event.start,
        end: event.end,
      });
    } catch (error) {
      logDateSerializationError(
        "createNewEvent",
        {
          start: event?.start,
          end: event?.end,
          allDay: event?.allDay,
        },
        error
      );
      return;
    }

    const startDate = new Date(persistedDateFields.start);
    const endDate = new Date(persistedDateFields.end);
    const startUNIX = startDate.getTime() / 1000;
    const endUNIX = endDate.getTime() / 1000;

    if (endUNIX - startUNIX === 900) if (!event.synthetic) return;

    let studio = "";

    if (event.allDay) studio = "Staff";
    if (!currentStaffData.isSuperAdmin) {
      if (!currentStaffData.isAdmin) {
        studio = "Staff";
        if (!event.allDay) return;
      }
    }
    const newEvent = {
      ...newJobObject,
      allDay: event.allDay,
      ...persistedDateFields,
      studio: studio,
      year: new Date(persistedDateFields.start).getFullYear(),
      checklists: [
        {
          name: "Colour Corrections",
          id: uuidv4(),
          checklistItems: [],
        },
        {
          name: "Colour Changes",
          id: uuidv4(),
          checklistItems: [],
        },
        {
          name: "Retouching Notes",
          id: uuidv4(),
          checklistItems: [],
        },
      ],
    };
    await addDoc(collection(db, "JobData"), newEvent);
  };
  const handleEventResize = async (event) => {
    if (!currentStaffData) {
      resetEvent(event);
      return;
    }
    if (currentStaffData.isUtility) {
      resetEvent(event);
      return;
    }
    if (!currentStaffData.isAdmin) {
      resetEvent(event);
      return;
    }

    let persistedDateFields;
    try {
      persistedDateFields = buildPersistedDateFields({
        start: event?.event?.start,
        end: event?.event?.end,
      });
    } catch (error) {
      logDateSerializationError(
        "handleEventResize",
        {
          start: event?.event?.start,
          end: event?.event?.end,
          allDay: event?.event?.allDay,
          id: event?.event?.id,
        },
        error
      );
      resetEvent(event);
      return;
    }

    await runTransaction(db, async (transaction) => {
      const jobDocRef = doc(db, "JobData", event.event.id);
      const jobDoc = await transaction.get(jobDocRef);
      if (!jobDoc.exists()) {
        console.log("Document does not exist!");
        return;
      }

      const jobData = jobDoc.data();

      const cleanData = (obj) => {
        return Object.fromEntries(
          Object.entries(obj).map(([k, v]) => [k, v === undefined ? null : v])
        );
      };

      // Calculate dayType based on new times
      const dayTypeFields = getDayTypeUpdateFields(
        jobData.jobTypeFull,
        persistedDateFields.bookedStart,
        persistedDateFields.bookedFinish
      );

      transaction.update(
        jobDocRef,
        cleanData({
          allDay: event.event.allDay,
          ...persistedDateFields,
          ...dayTypeFields,
        })
      );
    });
  };
  const [isEditable, setIsEditable] = useState(isMobile ? false : true);
  const handleEventDrop = async (event) => {
    if (
      event.event.extendedProps.isPublicHoliday ||
      event.event.extendedProps.isBirthday
    ) {
      return;
    }
    setIsEditable(false);
    try {
      // Check if this is a valid drop with a start date
      if (!event.event || !event.event.start) {
        resetEvent(event);
        return;
      }

      // Check permissions
      if (!currentStaffData) {
        resetEvent(event);
        return;
      }
      if (currentStaffData.isUtility) {
        resetEvent(event);
        return;
      }
      if (!currentStaffData.isAdmin) {
        resetEvent(event);
        return;
      }
      // if (!currentStaffData.isSuperAdmin) {
      //   resetEvent(event);
      //   return;
      // }

      // Check if the event was actually moved to a new time
      const sameTime =
        event.oldEvent.start.getTime() === event.event.start.getTime() &&
        (!event.oldEvent.end ||
          !event.event.end ||
          event.oldEvent.end.getTime() === event.event.end.getTime());

      if (sameTime) {
        // No actual change in time, just revert
        resetEvent(event);
        return;
      }

      let persistedDateFields;
      try {
        persistedDateFields = buildPersistedDateFields({
          start: event?.event?.start,
          end: event?.event?.end,
        });
      } catch (error) {
        logDateSerializationError(
          "handleEventDrop",
          {
            start: event?.event?.start,
            end: event?.event?.end,
            allDay: event?.event?.allDay,
            id: event?.event?.id,
          },
          error
        );
        resetEvent(event);
        return;
      }

      await runTransaction(db, async (transaction) => {
        const jobDocRef = doc(db, "JobData", event.event.id);
        const jobDoc = await transaction.get(jobDocRef);
        if (!jobDoc.exists()) {
          console.log("Document does not exist!");
          return;
        }

        const jobData = jobDoc.data();

        // Calculate dayType based on new times
        const dayTypeFields = getDayTypeUpdateFields(
          jobData.jobTypeFull,
          persistedDateFields.bookedStart,
          persistedDateFields.bookedFinish
        );

        transaction.update(jobDocRef, {
          allDay: event.event.allDay,
          ...persistedDateFields,
          ...dayTypeFields,
        });
      });

      // Force refresh the calendar to ensure UI is in sync with data
      calendarRef.current.getApi().refetchEvents();
    } catch (error) {
      console.error("Error in handleEventDrop:", error);
      resetEvent(event);
    } finally {
      setIsEditable(true);
    }
  };

  let clicks = 0;
  let timer = setTimeout(() => { }, 500);
  let dateClicked = "";
  const resetClicks = () => {
    clicks = 0;
    clearTimeout(timer);
    dateClicked = "";
  };
  const parseCalendarWidth = () => {
    return "98vw";
  };
  const [popoverAnchorEl, setPopoverAnchorEl] = useState(null);
  const [popoverOpen, setPopoverOpen] = useState(false);

  const handlePopoverClick = (event) => {
    setPopoverAnchorEl(event.currentTarget);
    setPopoverOpen(true);
  };

  const handlePopoverClose = () => {
    setPopoverOpen(false);
    setPopoverAnchorEl(null);
  };

  const [, setLoadingVisible] = useState(false);

  const [confirmationStatusEmailOpen, setConfirmationStatusEmailOpen] =
    useState(false);

  const [confirmationEmailData, setConfirmationEmailData] = useState({});

  const [
    firstConfirmationStatusEmailOpen,
    setFirstConfirmationStatusEmailOpen,
  ] = useState(false);

  const bgRand = randomIntFromInterval(
    1,
    20000,
    [adamFace, soriahface],
    isMobile
  );

  useEffect(() => {
    const allDayMaxHeight = () => {
      if (!isMobile) return;
      const elements = Array.from(
        document.getElementsByClassName("fc-scroller-harness")
      );
      elements[1].style.maxHeight = "230px";
      elements[1].style.overflow = "scroll";
    };
    allDayMaxHeight();
  }, [isMobile]);

  useEffect(() => {
    const iconColor = theme === "dark" ? "#ffffff" : "#000000";

    // Remove all SVGs from all primary buttons, but keep text content
    const allPrimaryButtons = document.querySelectorAll(".fc-button-primary");
    allPrimaryButtons.forEach((button) => {
      button.style.padding = "";
      const svgs = button.querySelectorAll("svg");
      svgs.forEach((svg) => svg.remove());
    });

    // Only target our specific custom buttons, not FullCalendar's built-in buttons
    const mobileMenuBtn = document.querySelector(".fc-mobileMenuButton-button");
    if (
      mobileMenuBtn &&
      mobileMenuBtn.classList.contains("fc-mobileMenuButton-button")
    ) {
      mobileMenuBtn.style.padding = "10px";
      mobileMenuBtn.textContent = "";
      mobileMenuBtn.innerHTML = `<svg width="16" height="16" viewBox="0 0 24 24" fill="${iconColor}"><path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/></svg>`;
    }

    const filtersBtn = document.querySelector(".fc-filters-button");
    if (filtersBtn && filtersBtn.classList.contains("fc-filters-button")) {
      filtersBtn.style.padding = "10px";
      filtersBtn.textContent = "";
      filtersBtn.innerHTML = `<svg width="16" height="16" viewBox="0 0 24 24" fill="${iconColor}"><path d="M4.25 5.61C6.27 8.2 10 13 10 13v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-6s3.73-4.8 5.75-7.39C20.25 4.95 19.78 4 18.95 4H5.04c-.83 0-1.3.95-.79 1.61z"/></svg>`;
    }

    const toggleBtn = document.querySelector(".fc-toggleListView-button");
    if (toggleBtn && toggleBtn.classList.contains("fc-toggleListView-button")) {
      toggleBtn.style.padding = "10px";
      toggleBtn.textContent = "";
      if (isListView) {
        toggleBtn.innerHTML = `<svg width="16" height="16" viewBox="0 0 24 24" fill="${iconColor}"><path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM8 18H4V6h4v12zm6 0h-4V6h4v12zm6 0h-4V6h4v12z"/></svg>`;
        hideDock();
      } else {
        toggleBtn.innerHTML = `<svg width="16" height="16" viewBox="0 0 24 24" fill="${iconColor}"><path d="M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z"/></svg>`;
        showDock();
      }
    }
  }, [isListView, theme, isMobile]);

  const [isDebouncing] = useAtom(isDebouncingAtom);
  return (
    <>
      <CalendarGlobalStyles
        theme={theme}
        bgRand={bgRand}
        adamFace={adamFace}
        soriahface={soriahface}
        adamImage={adamImage}
        soriahImage={soriahImage}
      />
      <ExportDatesModal
        exportDatesModalOpen={exportDatesModalOpen}
        setExportDatesModalOpen={setExportDatesModalOpen}
        jobTypes={jobTypes}
        studios={studios}
        clientData={clientData}
        staffData={staffData}
        theme={theme}
      />
      <Modal
        open={confirmationStatusEmailOpen}
        onClose={() => {
          setConfirmationStatusEmailOpen(false);
        }}
        closeAfterTransition
      >
        <Slide
          direction="up"
          in={confirmationStatusEmailOpen}
          mountOnEnter
          unmountOnExit
          timeout={200}
        >
          <div
            id="confirmationEmailModalBG"
            style={{
              top: 0,
              bottom: 0,
              left: 0,
              right: 0,
              height: height,
            }}
            onClick={(e) => {
              if (e.target.id === "confirmationEmailModalBG") {
                setConfirmationStatusEmailOpen(false);
              }
            }}
          >
            <div
              style={{
                width: isMobile ? "90vw" : 750,
                height: "90vh",
                background: "#ffffff",
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
              }}
            >
              <ConfirmedEmailV2
                open={true}
                onClose={() => setConfirmationStatusEmailOpen(false)}
                confirmationEmailData={confirmationEmailData}
                isMobile={isMobile}
                theme={theme}
              />
            </div>
          </div>
        </Slide>
      </Modal>
      <Modal
        open={firstConfirmationStatusEmailOpen}
        onClose={() => {
          setFirstConfirmationStatusEmailOpen(false);
        }}
        closeAfterTransition
      >
        <Slide
          direction="up"
          in={firstConfirmationStatusEmailOpen}
          mountOnEnter
          unmountOnExit
          timeout={200}
        >
          <div
            id="confirmationEmailModalBG"
            style={{
              top: 0,
              bottom: 0,
              left: 0,
              right: 0,
              height: height,
            }}
            onClick={(e) => {
              if (e.target.id === "confirmationEmailModalBG") {
                setFirstConfirmationStatusEmailOpen(false);
              }
            }}
          >
            <div
              style={{
                width: isMobile ? "90vw" : 750,
                height: "90vh",
                background: "#ffffff",
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
              }}
            >
              <FirstConfirmationEmailV2
                open={true}
                onClose={() => setFirstConfirmationStatusEmailOpen(false)}
                confirmationEmailData={confirmationEmailData}
                isMobile={isMobile}
                theme={theme}
              />
            </div>
          </div>
        </Slide>
      </Modal>

      <Modal
        open={eventDataModalV2Open}
        onClose={() => {
          UpdateMetaThemeColour({
            light: returnBackgroundColour("light"),
            dark: returnBackgroundColour("dark"),
          });
          setEventDataModalV2Open(false);
          showDock();
        }}
        style={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: (() => {
            if (window.location.pathname.includes("kanban")) {
              return "center";
            }
            return modalAlignment === "left" ? "flex-start" : "center";
          })(),
          paddingTop: isMobile ? 0 : modalAlignment === "left" ? 0 : 10,
          paddingLeft: 0,
          backdropFilter: "blur(2px)",
          WebkitBackdropFilter: "blur(2px)",
        }}
      >
        <Slide
          direction={modalAlignment === "left" ? "right" : "up"}
          in={eventDataModalV2Open}
          mountOnEnter
          unmountOnExit
          timeout={120}
        >
          <div
            style={{
              minWidth: isMobile ? "calc(100vw - 15px)" : "750px",
              width: (() => {
                if (isMobile) return "calc(100vw - 15px)";
                if (window.location.pathname.includes("kanban")) {
                  return isMidSize ? "85vw" : "min(90vw, 1000px)";
                }
                if (modalAlignment === "left") {
                  return isMidSize ? "94vw" : "min(92vw, 1100px)";
                }
                return isMidSize ? "85vw" : "min(90vw, 1000px)";
              })(),
              maxWidth: "98vw",
              boxSizing: isMobile ? "border-box" : "initial",
              height: (() => {
                if (isMobile) return "100vh";
                if (window.location.pathname.includes("kanban")) {
                  return isDockHidden
                    ? `calc(100vh - 82px)`
                    : `calc(100vh - 125px)`;
                }
                if (modalAlignment === "left") {
                  return `calc(100vh - 14px)`;
                }
                return isDockHidden
                  ? `calc(100vh - 82px)`
                  : `calc(100vh - 125px)`;
              })(),
              background:
                theme === "dark" ? "rgb(28, 28, 28)" : "rgb(250, 250, 250)",
              zIndex: 1100,
              position: "relative",
              outline: "none",
              boxShadow: "0px 3px 10px rgba(0, 0, 0, 0.2)",
              overflowY: "auto",
              borderRadius: (() => {
                if (isMobile) return 0;
                if (window.location.pathname.includes("kanban")) {
                  return "10px";
                }
                if (modalAlignment === "left") {
                  return "0px";
                }
                return "10px";
              })(),
            }}
          >
            <div>
              <EventDataModalV2
                initialJobData={eventDataModal}
                eventDataModalOpen={eventDataModalV2Open}
                setEventDataModalOpen={setEventDataModalV2Open}
                isEventTomorrow={isEventTomorrow}
                confirmationStatusEmailOpen={confirmationStatusEmailOpen}
                setConfirmationStatusEmailOpen={setConfirmationStatusEmailOpen}
                firstConfirmationStatusEmailOpen={
                  firstConfirmationStatusEmailOpen
                }
                setFirstConfirmationStatusEmailOpen={
                  setFirstConfirmationStatusEmailOpen
                }
                setConfirmationEmailData={setConfirmationEmailData}
                clientData={clientData}
              />
            </div>
          </div>
        </Slide>
      </Modal>

      <div
        style={{
          display: eventDataModalOpen ? "block" : "none",
          height: "100%",
          background: "rgba(0,0,0,0.1)",
          zIndex: 1099,
          position: "absolute",
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
        }}
        onClick={() => {
          if (isDebouncing) return;
          setEventDataModalOpen(false);
          setTimeout(() => {
            showDock();
          }, 150);
          setEventDataModal({});
          history.push(location.pathname);
        }}
      ></div>
      <FiltersPopover
        anchorEl={popoverAnchorEl}
        open={popoverOpen}
        onClose={handlePopoverClose}
        isMobile={isMobile}
        queryFilter={queryFilter}
        setQueryFilter={setQueryFilter}
        clientData={clientData}
        staffData={staffData}
        studios={studios}
        calendarColours={calendarColours}
        showStaff={showStaff}
        setShowStaff={setShowStaff}
        broadClientFilter={broadClientFilter}
        setBroadClientFilter={setBroadClientFilter}
        calendarRef={calendarRef}
        showWeekends={showWeekends}
        setShowWeekends={setShowWeekends}
        setExportDatesModalOpen={setExportDatesModalOpen}
      />
      <div
        id="calendarRoot"
        style={{
          width: parseCalendarWidth(),
          margin: 0,
          padding: 10,
        }}
        {...swipeHandlers}
      >
        <FullCalendar
          eventSources={[
            filteredEvents,
            recurringEvents,
            birthdays,
            publicHolidays,
          ]}
          height={`calc(${height}px - 90px)`}
          ref={calendarRef}
          plugins={[
            dayGridPlugin,
            interactionPlugin,
            timeGridPlugin,
            rrulePlugin,
            listPlugin,
          ]}
          views={{
            dayGridPlugin: {
              titleFormat: {
                year: "",
                month: "short",
                day: "2-digit",
              },
            },
            listMonth: {
              buttonText: "Month",
            },
            listWeek: {
              buttonText: "Week",
            },
            listDay: {
              buttonText: "Day",
            },
          }}
          allDaySlot={showStaff}
          droppable={false}
          initialView="timeGridWeek"
          longPressDelay={500}
          selectLongPressDelay={500}
          slotEventOverlap={false}
          slotDuration="00:15:00"
          scrollTime="07:50:00"
          eventOrder={isListView ? "start" : "studio,eventPrefix"}
          eventOrderStrict={true}
          locale={enAu}
          dateClick={(date) => {
            if (date.allDay) return; // let all-day interactions rely on FullCalendar select flow
            console.log("dateClick");
            if (currentStaffData.isUtility) return;
            // clicks++;
            // if (clicks === 1) {
            //   calendarRef.current.getApi().unselect();
            //   dateClicked = date.dateStr;
            //   timer = setTimeout(() => {
            //     resetClicks();
            //   }, 300);
            // } else {
            // if (dateClicked === date.dateStr) {
            let end = new Date(date.date);
            end.setMinutes(end.getMinutes() + 15);
            console.log(date.date);
            const obj = {
              start: date.date,
              end: end,
              allDay: false,
              synthetic: true,
            };
            createNewEvent(obj);
            // }
            // resetClicks();
            // }
          }}
          // dragToCreate={true}
          buttonText={{
            today: "Today",
            month: "Month",
            week: "Week",
            day: "Day",
            list: "List",
            listMonth: "Month",
            listWeek: "Week",
            listDay: "Day",
            dayGridMonth: "Month",
            timeGridWeek: "Week",
            timeGridDay: "Day",
          }}
          customButtons={{
            exportDates: {
              text: "Export Dates",
              click: () => {
                setExportDatesModalOpen(true);
              },
            },
            toggleWeekends: {
              text: "Weekends",
              click: async () => {
                setShowWeekends(!showWeekends);
                await updateDoc(doc(db, "StaffData", currentStaffData.id), {
                  showWeekends: !showWeekends,
                });
                // localStorage.setItem("showWeekends", !showWeekends);
              },
            },
            filters: {
              text: "",
              click: handlePopoverClick,
            },
            mobileMenuButton: {
              text: "",
              click: handlePopoverClick,
            },
            toggleListView: {
              text: "",
              hint: isListView
                ? "Switch to calendar view"
                : "Switch to list view",
              click: toggleListView,
            },
            customListMonth: {
              text: "Month",
              click: () => {
                if (!calendarRef.current) return;
                calendarRef.current.getApi().changeView("listMonth");
              },
            },
            customListWeek: {
              text: "Week",
              click: () => {
                if (!calendarRef.current) return;
                calendarRef.current.getApi().changeView("listWeek");
              },
            },
            customListDay: {
              text: "Day",
              click: () => {
                if (!calendarRef.current) return;
                calendarRef.current.getApi().changeView("listDay");
              },
            },
          }}
          headerToolbar={isMobile ? mobileToolbar : desktopToolbar}
          // footerToolbar={currentStaffData.isAdmin && !isMobile ? adminToolbar : null}
          selectable={true}
          selectMirror={true}
          weekends={showWeekends}
          // hiddenDays={[0, 6]}
          nowIndicator={true}
          eventTimeFormat={{
            hour: "numeric",
            minute: "2-digit",
            meridiem: "short",
          }}
          editable={isEditable}
          eventDrop={handleEventDrop}
          eventClick={(e) => {
            if (currentStaffData.isUtility) return;
            onEventClick(
              e,
              setEventDataModalOpen,
              setEventDataModal,
              hideDock,
              setEventDataModalV2Open,
              currentStaffData
            );
            if (isElectron) {
              window.ipcRenderer?.send("setShootWindowBounds");
              window.ipcRenderer?.send(
                "eval",
                `const winBounds = calendarWindow.getBounds();

              previousCalendarWindowBounds = winBounds;
              
              const theScreen = screen.getDisplayNearestPoint({
                x: winBounds.x,
                y: winBounds.y,
              });
              
              const windowNewWidth = 610;
              
              calendarWindow.center();
              
              let newWindowBounds = {
                y: 0,
                width: windowNewWidth,
                height: theScreen.workArea.height,
              };
              
              if (previousShootWindowBounds) {
                newWindowBounds.x = previousShootWindowBounds.x;
                newWindowBounds.y = previousShootWindowBounds.y;
                newWindowBounds.height = previousShootWindowBounds.height;
              }
              
              calendarWindow.setBounds(newWindowBounds, false);
              
              if (!previousShootWindowBounds) calendarWindow.center();
              `
              );
            }
          }}
          eventResize={handleEventResize}
          select={(e) => {
            console.log("select");
            createNewEvent(e);
          }}
          eventContent={(e) =>
            eventContentWithListView(
              e,
              staffData,
              filteredEvents,
              showDoubles,
              isListView,
              calendarColours,
              theme
            )
          }
          datesSet={(info) => {
            setCurrentView(info.view.type);

            // Update list view state based on current view
            const listViews = ["listMonth", "listWeek", "listDay"];
            setIsListView(listViews.includes(info.view.type));

            let start = new Date(info.start);
            let end = new Date(info.end);

            if (startEndDate.startDate === null) {
              start.setDate(start.getDate(start) - 2);
              end.setDate(end.getDate(end) + 2);
              setStartEndDate({
                startDate: getFilterDate(start),
                endDate: getFilterDate(end),
              });
              return;
            } else {
              let startContains = false;
              let endContains = false;
              if (
                start > new Date(startEndDate.startDate) &&
                start < new Date(startEndDate.endDate)
              ) {
                startContains = true;
              } else {
              }
              if (
                end > new Date(startEndDate.startDate) &&
                end < new Date(startEndDate.endDate)
              ) {
                endContains = true;
              } else {
              }

              if (!startContains || !endContains) {
                start.setDate(start.getDate(start) - 2);
                end.setDate(end.getDate(end) + 2);
                setStartEndDate({
                  startDate: getFilterDate(start),
                  endDate: getFilterDate(end),
                });
              }
            }
          }}
          viewClassNames={theme === "dark" ? "darkModeBorder" : ""}
          eventDidMount={async (event) => {
            if (
              event.event.extendedProps.studio &&
              !event.event.extendedProps.studio.includes("Studio")
            ) {
              if (
                getTimeDifferenceInHours(
                  event.event.extendedProps.bookedStart,
                  event.event.extendedProps.bookedFinish
                ) < 2
              ) {
                event.el.parentElement.style.width = "100%";
                event.el.parentElement.style.zIndex = "10";
                event.el.parentElement.style.left = "10";
              }
            }

            if (event.event.extendedProps.isBirthday) {
              let sameDay = false;
              const now = DateTime.now()
                .setZone("Australia/Sydney")
                .startOf("day");
              const eStart = DateTime.fromISO(
                new Date(event.event.start).toISOString()
              ).startOf("day");

              if (now.ts === eStart.ts) sameDay = true;

              event.el.style.background =
                "linear-gradient(90deg, rgba(226,156,228,1) 0%, rgba(171,240,243,1) 100%)";
              const { top, bottom, left, right } =
                event.el.getBoundingClientRect();

              confetti.default({
                origin: {
                  x: (left + right) / 2 / window.innerWidth,
                  y: (top + 100 + bottom) / 2 / window.innerHeight,
                },
                particleCount: sameDay ? 100 : 2,
                spread: sameDay ? 40 : 10,
                ticks: 250,
              });
            }

            if (event.event.extendedProps.isPublicHoliday) {
              if (theme === "dark") {
                event.el.style.background =
                  "repeating-linear-gradient(45deg, rgba(100,150,200,0.6), rgba(100,150,200,0.6) 10px, rgba(60,60,60,0.6) 10px, rgba(60,60,60,0.6) 20px)";
              } else {
                event.el.style.background =
                  "repeating-linear-gradient(45deg, rgba(179,217,255,0.8), rgba(179,217,255,0.8) 10px, rgba(255,255,255,0.8) 10px, rgba(255,255,255,0.8) 20px)";
              }
            }

            event.el.style.boxShadow = "0px 0px 0px 0px #fff !important";
            event.el.style.marginTop = event.event.allDay ? "0.6px" : "2.5px";
            event.el.style.marginBottom = event.event.allDay
              ? "0.6px"
              : "2.5px";
            event.el.style.marginLeft = "1.5px";
            event.el.style.marginRight = "1.5px";

            event.el.style.borderRadius = "6px";

            const transparentStudios = [
              "Staff",
              "N/A",
              "Critical Events",
              "Post Production",
              "Adam",
            ];

            if (
              event.event.extendedProps.studio &&
              transparentStudios.includes(event.event.extendedProps.studio) &&
              !event.event.allDay
            ) {
              const bgColor = event.el.style.backgroundColor;
              const rgbMatch = bgColor.match(
                /rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)/
              );

              if (rgbMatch) {
                const r = rgbMatch[1];
                const g = rgbMatch[2];
                const b = rgbMatch[3];

                event.el.style.backgroundColor = `rgba(${r}, ${g}, ${b}, 0.4)`;

                event.el.addEventListener("mouseenter", function () {
                  const r = rgbMatch[1];
                  const g = rgbMatch[2];
                  const b = rgbMatch[3];
                  const a = rgbMatch[4];

                  event.el.style.backgroundColor = `rgba(${r}, ${g}, ${b}, ${a})`;
                });

                event.el.addEventListener("mouseleave", function () {
                  const r = rgbMatch[1];
                  const g = rgbMatch[2];
                  const b = rgbMatch[3];
                  event.el.style.backgroundColor = `rgba(${r}, ${g}, ${b}, 0.4)`;
                });
              }
            }

            if (!currentStaffData) return;
            if (!currentStaffData.id) return;

            let border = false;
            if (!event.event.extendedProps.isAdditionalDate) {
              if (
                currentStaffData.id === event.event.extendedProps.photographer
              ) {
                border = true;
              }
              if (currentStaffData.id === event.event.extendedProps.operator) {
                border = true;
              }
              if (currentStaffData.id === event.event.extendedProps.stylist) {
                border = true;
              }
              if (
                event.event.extendedProps.additionalPhotographers?.includes(
                  currentStaffData.id
                )
              ) {
                border = true;
              }
              if (
                event.event.extendedProps.additionalOperators?.includes(
                  currentStaffData.id
                )
              ) {
                border = true;
              }
              if (
                event.event.extendedProps.additionalStylists?.includes(
                  currentStaffData.id
                )
              ) {
                border = true;
              }
            } else {
              let exProps = event.event.extendedProps;
              let theDate =
                exProps.additionalDates[exProps.additionalDateIndex];
              if (currentStaffData.id === theDate.photographer) {
                border = true;
              }
              if (currentStaffData.id === theDate.operator) {
                border = true;
              }
              if (currentStaffData.id === theDate.stylist) {
                border = true;
              }
              if (
                theDate.additionalPhotographers?.includes(currentStaffData.id)
              ) {
                border = true;
              }
              if (theDate.additionalOperators?.includes(currentStaffData.id)) {
                border = true;
              }
              if (theDate.additionalStylists?.includes(currentStaffData.id)) {
                border = true;
              }
            }
            if (border) {
              event.el.style.border = `3px solid ${event.textColor}`;
            }
          }}
        />
      </div>
    </>
  );
};
export default Calendar;

const onEventClick = (
  event,
  setEventDataModalOpen,
  setEventDataModal,
  hideDock,
  setEventDataModalV2Open,
  currentStaffData
) => {
  if (
    event.event.extendedProps.isPublicHoliday ||
    event.event.extendedProps.isBirthday
  ) {
    return;
  }
  setEventDataModal({});
  if (!event.event.extendedProps.staffAllDay) {
    // setEventDataModalOpen(true);
    hideDock();
    setTimeout(() => {
      setEventDataModal(event.event);
    }, 5);
    setTimeout(() => {
      // if (currentStaffData.id === "8jXVYoCymxHLQngklbWE") {
      setEventDataModalV2Open(true);
      // } else {
      //   setEventDataModalOpen(true);
      // }
    }, 10);
    setTimeout(() => {
      UpdateMetaThemeColour({
        light: "#fafafa",
        dark: "#1c1c1c",
      });
    }, 110);
  }
};
const parseStartEndTime = (
  bookedStart,
  bookedFinish,
  shootDate,
  kind,
  data
) => {
  let which;
  if (kind === "startDate") {
    which = bookedStart;
  } else if (kind === "endDate") {
    which = bookedFinish;
  }
  try {
    shootDate = shootDate.toDate();
  } catch (e) {
    shootDate = parseDate(shootDate);
  }
  try {
    shootDate.setMinutes(which.toDate().getMinutes());
    shootDate.setHours(which.toDate().getHours());

    const newDate = new Date(shootDate);
    return newDate.toISOString();
  } catch (e) {
    return new Date(which).toISOString();
  }
};
const parseDate = (date) => {
  if (!date) {
    return null;
  }
  const datepattern = new RegExp(/\D* \d\d\/\d\d\/\d\d\d\d/);
  let datetmp;
  try {
    datepattern.test(date)
      ? (datetmp = parseit(date))
      : (datetmp = date.toDate());
    datetmp = new Date(datetmp);
  } catch (e) {
    datetmp = null;
  }
  return datetmp;

  function parseit(date) {
    const replace = date.replace(/\D\D\D /, "");
    const split = replace.split("/");
    let newDate = `${split[2]}-${split[1]}-${split[0]}`;
    newDate = newDate.toString().replace(/ /g, "");
    return newDate;
  }
};
function toIsoStringOrNull(value) {
  if (value === null || value === undefined) {
    return null;
  }

  const rawDate =
    value && typeof value.toDate === "function" ? value.toDate() : value;
  const normalizedDate = rawDate instanceof Date ? rawDate : new Date(rawDate);

  if (Number.isNaN(normalizedDate.getTime())) {
    throw new Error("Invalid date value");
  }

  return normalizedDate.toISOString();
}

function buildPersistedDateFields({ start, end }) {
  const startIso = toIsoStringOrNull(start);

  if (!startIso) {
    throw new Error("Start date is required");
  }

  let endIso = toIsoStringOrNull(end);

  if (!endIso) {
    const fallbackEnd = new Date(startIso);
    fallbackEnd.setMinutes(fallbackEnd.getMinutes() + 30);
    endIso = fallbackEnd.toISOString();
  }

  return {
    start: startIso,
    end: endIso,
    shootDate: startIso,
    bookedStart: startIso,
    bookedFinish: endIso,
  };
}

function logDateSerializationError(writePath, values, error) {
  console.error(`Failed to serialize calendar dates in ${writePath}`, {
    values,
    error,
  });
}

function getFilterDate(date) {
  var tzo = -date.getTimezoneOffset(),
    dif = tzo >= 0 ? "+" : "-",
    pad = function (num) {
      return (num < 10 ? "0" : "") + num;
    };

  return (
    date.getFullYear() +
    "-" +
    pad(date.getMonth() + 1) +
    "-" +
    pad(date.getDate()) +
    "T" +
    pad(date.getHours()) +
    ":" +
    pad(date.getMinutes()) +
    ":" +
    pad(date.getSeconds()) +
    dif +
    pad(Math.floor(Math.abs(tzo) / 60)) +
    ":" +
    pad(Math.abs(tzo) % 60)
  );
}

const isEventTomorrow = (isoString) => {
  const jobTime = DateTime.fromISO(isoString).setZone("Australia/Sydney");
  const tomorrowStart = DateTime.now()
    .setZone("Australia/Sydney")
    .startOf("day")
    .plus({ days: 1 });

  const tomorrowEnd = DateTime.now()
    .setZone("Australia/Sydney")
    .endOf("day")
    .plus({ days: 1 });

  return (
    tomorrowStart.toSeconds() <= jobTime.toSeconds() &&
    jobTime.toSeconds() <= tomorrowEnd.toSeconds()
  );
};
async function randomIntFromInterval(min, max, specialNums, isMobile) {
  const randRef = doc(db, "increments", "randomIntFromInterval");
  await updateDoc(randRef, { int: increment(1) });

  let rand = Math.floor(Math.random() * (max - min + 1) + min);
  if (isMobile) rand = rand + 1;

  specialNums.forEach(async (num) => {
    if (rand === num) {
      await updateDoc(randRef, { specialCalled: increment(1) });
    }
  });
  return rand;
}
// eslint-disable-next-line
function parseBirthday(birthday, e) {
  try {
    const bday = new Date(birthday);
    const event = new Date(e.event.start);
    const eventYear = event.getFullYear();
    const bdayYear = bday.getFullYear();
    const age = eventYear - bdayYear;
    return `${age}${nthNumber(age)}`;
  } catch (e) {
    return null;
  }
}
const nthNumber = (number) => {
  if (number > 3 && number < 21) return "th";
  switch (number % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
};
function getTimeDifferenceInHours(isoString1, isoString2) {
  const dateTime1 = DateTime.fromISO(isoString1);
  const dateTime2 = DateTime.fromISO(isoString2);
  const diffInMilliseconds = dateTime2.diff(
    dateTime1,
    "milliseconds"
  ).milliseconds;
  const hoursDifference = diffInMilliseconds / (1000 * 60 * 60);
  return parseFloat(hoursDifference.toFixed(1));
}
